import React from 'react';
import {Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';

import Button from 'components/Button';
import ErrorBlock from 'components/ErrorBlock';
import {CheckBoxField, ExpandingTextAreaField} from 'components/Fields';

import './styles.css';

const formSubmit = (values, _dispatch, props) => {
  const {text, requiresAction} = values;

  props.submitAction({text, requiresAction});
};

class RequiresActionNoteForm extends React.Component<any> {
  triggerSubmit = () => {
    this.props.submit(this.props.formName);
  };

  onKeyDown = event => {
    const {submitting} = this.props;

    // textarea does not have keyCode property onChange, that's why we do this
    // onkeyDown and exclude shift + enter
    if (
      event.keyCode === 13 &&
      event.shiftKey === false &&
      submitting === false
    ) {
      event.preventDefault();
      this.triggerSubmit();
    }
  };

  render() {
    const {error, submitting, handleSubmit} = this.props;

    return (
      <form className="RequiresActionNoteForm" onSubmit={handleSubmit}>
        {error && <ErrorBlock>{error}</ErrorBlock>}

        <Field
          name="text"
          className="textArea"
          component={ExpandingTextAreaField}
          placeholder="Add note..."
          minHeight="6rem"
          maxHeight="10rem"
          onKeyDown={this.onKeyDown}
        />
        <div className="options">
          <Field
            className="requiresActionCheckBox"
            name="requiresAction"
            component={CheckBoxField}
            label="Requires action"
          />
          <div className="buttons">
            <Button
              white
              className="cancelButton"
              type="button"
              onClick={this.props.closeForm}>
              Cancel
            </Button>
            <Button
              className="addNoteButton"
              onClick={this.triggerSubmit}
              blue={!submitting}
              isLoading={submitting}
              disabled={submitting}>
              Done
            </Button>
          </div>
        </div>
      </form>
    );
  }
}

const mapStateToProps = (_state, props) => ({
  form: props.formName,
  initialValues: {
    requiresAction: false
  }
});

export default connect(mapStateToProps)(
  reduxForm({
    onSubmit: formSubmit
  })(RequiresActionNoteForm)
);
